import { createSession, getSession, endSession, clearSession } from './session';
import { initHotReloadCollector } from './collectors/hot-reload';
import { sendSessionToDatadog } from './transports/datadog';
import { log } from './utils/logger';

let initialized = false;
export async function initDevMetrics(
  application: string = process.env['NEXT_PUBLIC_SERVICE_NAME'] ?? 'unknown',
  verbose = false,
) {
  if (initialized || typeof window === 'undefined') return;
  if (process.env.NODE_ENV !== 'development') {
    if (verbose) {
      log('warn', 'Dev metrics are only available in development mode');
    }
    return;
  }
  const devCommand = process.env['NEXT_PUBLIC_TURBOPACK'] ? 'turbopack' : 'dev';
  initialized = true;
  const previous = getSession(application);

  if (previous && previous.hotReloads?.length) {
    if (verbose) {
      log(
        'debug',
        `📤 Sending previous session for ${application}:`,
        previous.sessionId,
      );
    }
    sendSessionToDatadog(previous, verbose);
    clearSession(application);
  }

  const session = createSession(application, devCommand);
  initHotReloadCollector(application, verbose);

  window.addEventListener('beforeunload', async () => {
    endSession(application);
  });

  if (verbose) {
    log(
      'debug',
      `[${application}] New dev session started: ${session.sessionId}`,
    );
  }
}

export function resetDevMetrics() {
  initialized = false;
}
